import styled from "styled-components";
import { ModalStyledProps } from "./@types";
import { Box, Flex } from "rebass/styled-components";
import { Headline } from "../../../../Components/Text";
import { Button } from "../../../../Components/Button";

export const Headers = styled(Flex)`
  flex-direction: row;
  align-items: flex-start;
  align-content: center;
  justify-content: flex-start;
  margin-right: 20px;
  margin-bottom: 15px;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
  gap: 15px;

  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    gap: 12px;
    margin-bottom: 12px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
    margin-right: 0;
  }
`;

export const StyledHeading = styled(Headline)`
  font-weight: 600;
  display: flex;
  min-width: 90px;
  align-items: center;
  height: 35px;
  margin: 0;
  flex-shrink: 0;
`;

export const ClipsList = styled(Box)`
  width: 99%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  grid-column-gap: 15px;
  grid-row-gap: 15px;
  overflow-y: scroll;
  height: auto;
  margin-bottom: 69px;
  ::-webkit-scrollbar-corner {
    background: ${({ theme }) => theme.colors.ned};
  }
  ::-webkit-scrollbar {
    width: 25px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.midnightAlpha50};
    border: 5px solid transparent;
    border-radius: 999px;
    background-clip: content-box;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.colors.midnightAlpha90};
  }
`;

export const AddButtonContainer = styled.div`
  height: 90px;
  width: 100%;
  display: flex;
  background: ${({ theme }) => theme.colors.ned};
  position: absolute;
  bottom: 0px;
  right: 0px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  justify-content: space-between;
  align-items: center;
  z-index: 100;
  box-shadow: 0px -10px 10px #18252d80;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    height: 60px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    position: fixed;
    bottom: 45px;
    left: 10px;
    right: 10px;
    width: calc(100% - 20px);
    border-radius: 20px;
    z-index: 1001;
    height: 70px;
    background: ${({ theme }) => theme.colors.darkerNed};
    box-shadow: 0px 0px 15px #18252d80;
  }
`;

export const AddButton = styled(Button)<{ disabled: boolean }>`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-left: 15px;
  margin-right: 25px;
  width: 90px;
  color: ${(props: { disabled: boolean }) =>
    props.disabled ? "#8FA9AF" : "#F7FCFD"};
  background: ${(props: { disabled: boolean }) =>
    props.disabled ? "#213442" : "#4DBD94"};
  transition: 0.2s ease;
  ${(props: { disabled: boolean }) =>
    props.disabled
      ? ""
      : "&:hover { cursor: pointer; background: #4dbd9490; }"};
`;

export const ModalContent = styled(Flex)`
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: calc(40vw - 40px);
  height: min(650px, calc(100vh - 40px));
  max-height: calc(100vh - 40px);
  justify-content: start;
  background: ${({ theme }) => theme.colors.ned};
  box-sizing: border-box;
  border-radius: 16px;
  z-index: 1050;
  padding: 20px;
  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    width: 100vw;
    height: 100vh;
    max-width: 100vw;
    max-height: 100vh;
    left: 0;
    top: 0;
    transform: none;
    border-radius: 0;
    padding: 20px 15px;
  }
  @media (max-width: ${({ theme }) => theme.breaks.small}) {
    height: 100vh;
  }
`;

export const ClipsModal = styled.div<ModalStyledProps>`
  display: ${(props) => (props.isOpen ? "block" : "none")};
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: visible;
  outline: 0;
  background-color: rgba(12, 19, 24, 0.8);
`;
export const FilterContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 35px;
  flex-wrap: wrap;
  padding: 0;
  flex-direction: row;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colors.ice};
  gap: 8px;
  font-weight: 500;
  z-index: 100;
  overflow: hidden;

  @media (max-width: ${({ theme }) => theme.breaks.medium}) {
    gap: 10px;
    font-size: 12px;
  }

  @media (max-width: ${({ theme }) => theme.breaks.standard}) {
    gap: 8px;
  }
`;

export const Select = styled.select`
  all: unset;
  background: ${({ theme }) => theme.colors.navy};
  border-radius: 8px;
  border: 0px solid transparent;
  font-weight: 500;
  font-size: 13px;
  padding: 6px 10px;
  height: 35px;
  margin-left: 0px;
  justify-content: flex-start;
  text-align: left;
  min-width: 30px;
  max-width: 90px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.envy};
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;
